<script>
  import { makeId } from '../utils.js'; 
  import Tags from './Tags.svelte';

  export let label = "";
  export let placeholder = "";
  export let tags = "";
  export let autocompleteTags = [];
  export let helpText = "";
  export let width = undefined;

  $: inputId = label + makeId(10);
</script>

<div class="container tags-input" style="width: ${width};">
  <label for={inputId} class="label">{label}</label>
  <Tags id={inputId} {placeholder} bind:tags autoComplete={autocompleteTags} addKeys={[9,13]} removeKeys={[8]} splitWith={","} onlyUnique allowBlur on:tags />
  <span class="helpText">{helpText}</span>
</div>

<style>
  .container {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    width: auto;
    height: auto;
    pointer-events: auto;
  }

  label {
    text-align: left;
    padding: 0px 4px;
    color: #333;
    font-size: var(--label-font-size)px;
  }

  .helpText {
    display: block;
    position: relative;
    text-align: left;
    top: -2px;
    left: 4px;
    margin-top: 0px;
    font-size: 13px;
    font-style: italic;
    color: #777;
  }
</style>